export const GENERIC_ERROR = "Something went wrong. Please try again.";
export const NETWORK_ERROR = "We can't reach MetWorth right now. Check your connection and try again.";
export const SESSION_EXPIRED = "Your session expired. Please sign in again.";

const isNetworkError = (e) =>
  e?.name === "AuthRetryableFetchError" ||
  e?.status === 0 ||
  /failed to fetch|networkerror|network request failed|load failed/i.test(e?.message || "");

export function friendlyStorageError(e) {
  if (isNetworkError(e)) return NETWORK_ERROR;
  if (e?.code === "session_missing") return SESSION_EXPIRED;
  const status = String(e?.statusCode || e?.status || "");
  const msg = (e?.message || "").toLowerCase();
  if (status === "413" || msg.includes("exceeded") || msg.includes("too large")) return "This image is too large. Please use one under 5 MB.";
  if (status === "415" || msg.includes("mime")) return "This file type isn't supported.";
  if (status === "403" || msg.includes("row-level security") || msg.includes("unauthorized")) return "You don't have permission to upload here. Please sign in again.";
  return "We couldn't upload your image. Please try again.";
}

export function friendlyAuthError(e) {
  if (!e) return null;
  if (isNetworkError(e)) return NETWORK_ERROR;
  const code = e.code || "";
  const msg = (e.message || "").toLowerCase();
  if (code === "invalid_credentials" || msg.includes("invalid login credentials"))
    return "Email or password is incorrect.";
  if (code === "email_not_confirmed" || msg.includes("email not confirmed"))
    return "Please confirm your email address first. Check your inbox for the confirmation link.";
  if (code === "user_already_exists" || code === "email_exists" || msg.includes("already registered"))
    return "We couldn't create an account with these details. If you already have one, sign in instead.";
  if (code === "weak_password" || msg.includes("password should"))
    return "Please choose a stronger password (at least 8 characters).";
  if (code === "signup_disabled") return "New sign-ups are currently closed.";
  if (code === "otp_expired" || code === "flow_state_expired" || code === "flow_state_not_found")
    return "This link has expired or was already used.";
  if (e.status === 429 || code.startsWith("over_"))
    return "Too many attempts. Please wait a minute and try again.";
  if (code === "session_expired" || code === "refresh_token_not_found") return SESSION_EXPIRED;
  return GENERIC_ERROR;
}

export function friendlyDataError(e, fallback = GENERIC_ERROR) {
  if (isNetworkError(e)) return NETWORK_ERROR;
  if (e?.code === "session_missing") return SESSION_EXPIRED;
  if (e?.code === "PGRST301" || /jwt/i.test(e?.message || "")) return SESSION_EXPIRED;
  if (e?.code === "42501") return "You don't have permission to do that. Please sign in again.";
  return fallback;
}
